import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FeatureFlag } from '@app/enums';
import { Rep } from '@app/models/account/rep.model';
import { Company } from '@app/models/company/company.model';
import { Employee } from '@app/models/employee/employee.model';
import { AuthService, TranslationStorageService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { upsellCardMetaData } from '../../meta/upsell-meta';
import { upsellV2CardMetaData } from '../../meta/upsell-v2-meta';

@Component({
    templateUrl: './embed.template.html',
})
export class EmbedAddOnsView {
    moduleName = '';
    company: Company;
    employee: Employee;

    upsellCardMetaData = upsellCardMetaData;
    embedURL: SafeResourceUrl | string = '';

    queryParamsString: string;
    combinedUrl = '';
    salesRepFullName = '';

    upsellV2Enabled = false;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private auth: AuthService,
        private featureService: FeatureService,
        private translationStorage: TranslationStorageService
    ) {
        this.moduleName = this.route.snapshot.queryParamMap.get('moduleName') || '';
        this.company = this.auth.company || new Company();
        this.employee = this.auth.employee || new Employee();

        this.queryParamsString = `?firstName=${this.employee.firstName}&lastName=${
            this.employee.lastName
        }&email=${encodeURIComponent(this.auth.account ? this.auth.account.email : '')}&companySize=${
            this.company.employeeCount
        }&moduleName=${encodeURIComponent(this.moduleName)}&companyId=${this.company.id}&organizationId=${
            this.company.organizationId ?? ''
        }`;

        // Only want sales rep
        const companyReps = this.company.reps.filter((rep: Rep) => {
            return rep.type === 'sales';
        });

        if (companyReps.length) {
            this.salesRepFullName =
                companyReps[0].legalFirstName.toLowerCase() + '-' + companyReps[0].legalLastName.toLowerCase();

            this.queryParamsString =
                this.queryParamsString +
                `&salesRepFullName=${encodeURIComponent(this.salesRepFullName)}&salesRepEmail=${encodeURIComponent(
                    companyReps[0].email
                )}`;
        }
    }

    async ngOnInit(): Promise<void> {
        this.upsellV2Enabled = await this.featureService.has(FeatureFlag.upsellV2);

        const language = this.translationStorage.getLocale();
        this.queryParamsString += '&lng=' + language;
        this.combinedUrl = this.upsellV2Enabled
            ? upsellV2CardMetaData[this.moduleName].embedURL + this.queryParamsString
            : this.upsellCardMetaData[this.moduleName].embedURL + this.queryParamsString;

        this.embedURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.combinedUrl) ?? '';
    }
}
